import { Link, Outlet } from "react-router-dom";



function Home(props) {

  return (
    <div className="mainDisplay">
      <br />
      <h1 className="titleMain marginBottom darkMaroonText">
        ChicagoDAO Governance Portal
      </h1>

      <div className="row width100 justifyBetween">
        <div className="topWidgets widgetStyling ">
          <h1 className="title titleThin darkMaroonText">Portal Statistics</h1>
          <div className="row justifyBetween">
            <div className="statisticSubBox width46">
              <h1 className="subtitleThin darkMaroonText">
                <h1 className="titleCenter">3</h1>Total proposals
              </h1>
            </div>
            <div className="statisticSubBox width46">
              <h1 className="subtitleThin darkMaroonText">
                <h1 className="titleCenter">6</h1>Voting members
              </h1>
            </div>
          </div>
        </div>
        <div className="topWidgets widgetStyling center">
          <div className="center">
            <Link
              style={{
                pointerEvents: props.governanceValue > 0 ? "all" : "none",
                opacity: props.governanceValue > 0 ? 1 : 0.7,
              }}
              to="/proposal/new"
              className="noDecoration darkMaroonText titleThin statisticSubBox width90 basicPadding hoverMaroonBorder"
            >
              Create a new proposal
              {props.governanceValue ? (
                <></>
              ) : (
                <>
                  <br />
                  <i className="smallSubtitle">please connect a valid wallet</i>
                </>
              )}
            </Link>
          </div>
        </div>
      </div>
      <div className="fullWidget">
        <Outlet />
      </div>
    </div>
  );
}

export default Home;
